import {
  COLORS_FIRST_SERIES,
  COLORS_SECOND_SERIES,
  COLORS_BARS,
} from './utils';

const isDarkMode = (): boolean =>
  document.documentElement.getAttribute('data-theme') === 'dark';

export const getChartThemeColors = () => {
  const dark = isDarkMode();
  return {
    tooltipBorder: dark ? '#343448' : '#DDDDE8',
    tooltipBg: dark ? '#1c1c26' : '#fff',
    tooltipText: dark ? '#dcdce8' : '#333',
    axisLine: dark ? '#505068' : '#333',
    axisLabel: dark ? '#a8a8b8' : '#6E7079',
    axisLabelSecondary: dark ? '#8a8a9a' : '#999',
    splitLine: dark ? '#2e2e40' : '#E0E6F1',
    splitLineDashed: dark ? '#2e2e40' : '#E0E6F1',
    pieBorder: dark ? '#0d1117' : '#fff',
    markLine: dark ? '#5080e0' : '#1B5FF8',
    cardBg: dark ? '#0d1117' : '#fff',
    legendText: dark ? '#a8a8b8' : '#666',
    // Neutral gray line (e.g. average-position series): a lighter gray in dark mode so it
    // stays visible on the dark background.
    neutralLine: dark ? '#aaaab8' : '#7c7c88',
  };
};

// Softer, desaturated palettes for dark mode
const DARK_COLORS_FIRST_SERIES = [
  '#4db8ff', // was #009efd
  '#7ec8ab', // was #8CDCC1
  '#5b8af5', // was #1B5FF8
  '#8a8a9a', // was #303030
  '#809cf7', // was #6794FA
  '#8ea4d0', // was #B3C9FC
  '#7a7a8a', // was #959596
  '#3dbfa5', // was #00a189
  '#3aada8', // was #008b8a
  '#3a9aaa', // was #007481
  '#4a7d8e', // was #225d70
  '#6a9ab8', // was #4b789a
  '#4aafca', // was #1c98b3
  '#3acfcf', // was #00b7b7
  '#6ad8b5', // was #4cd3a5
  '#8ae098', // was #a0ea88
  '#3a7a50', // was #09522a
];

const DARK_COLORS_SECOND_SERIES = [
  '#6a9ab8', // was #4b789a
  '#4aafca', // was #1c98b3
  '#3acfcf', // was #00b7b7
  '#6ad8b5', // was #4cd3a5
  '#8ae098', // was #a0ea88
  '#3a7a50', // was #09522a
  '#4a9a48', // was #268120
  '#3a9a6a', // was #007947
  '#3a9080', // was #006f60
  '#3a8590', // was #00636b
  '#3a7a8a', // was #005567
];

const DARK_COLORS_BARS = [
  '#4a60b0', // was #0a2073
  '#c06060', // was #912b2b
  '#3aafa8', // was #11898c
];

export const getFirstSeriesPalette = (): string[] =>
  isDarkMode() ? DARK_COLORS_FIRST_SERIES : COLORS_FIRST_SERIES;

export const getSecondSeriesPalette = (): string[] =>
  isDarkMode() ? DARK_COLORS_SECOND_SERIES : COLORS_SECOND_SERIES;

export const getBarsPalette = (): string[] =>
  isDarkMode() ? DARK_COLORS_BARS : COLORS_BARS;
